import React from 'react';
import type {
    SearchSuggestion,
    SearchSuggestionGroup,
} from '../view-models/search-suggestion';
import { SearchSuggestionList } from './SearchSuggestionList';
import { cn } from '../../../utils/cn';

interface SearchSuggestionPopupProps {
    suggestionGroups: SearchSuggestionGroup[];
    query: string;
    onSearchSuggestionClick: (suggestion: SearchSuggestion | string) => void;
    variant?: 'default' | 'header';
    menuColor?: 'light' | 'dark';
}

export const SearchSuggestionPopup: React.FC<SearchSuggestionPopupProps> = ({
    suggestionGroups,
    query,
    onSearchSuggestionClick,
    variant = 'default',
    menuColor = 'dark',
}) => {
    const filteredSuggestionGroups = suggestionGroups.filter(
        (group) => group.options.length > 0
    );

    if (filteredSuggestionGroups.length === 0) {
        return <></>;
    }

    return (
        <div
            className={cn(
                'absolute left-2 right-2 top-full z-popover mt-2 p-8 pt-9',
                variant === 'header' && menuColor === 'light'
                    ? 'rounded-5 bg-black/20 pl-13.5 pt-9 shadow-lg backdrop-blur-xl'
                    : variant === 'header' && menuColor === 'dark'
                      ? 'rounded-5 bg-gray-100/40 pl-13.5 pt-9 shadow-lg backdrop-blur-xl'
                      : 'rounded-xl border border-gray-300 bg-white shadow-lg'
            )}
            id="search-autocomplete"
            aria-haspopup="listbox"
        >
            <div className="flex flex-col gap-4">
                {filteredSuggestionGroups.map((group, groupIndex) => (
                    <SearchSuggestionList
                        key={groupIndex}
                        group={group}
                        query={query}
                        variant={variant}
                        menuColor={menuColor}
                        onOptionClick={(suggestion) =>
                            onSearchSuggestionClick(suggestion)
                        }
                    />
                ))}
            </div>
        </div>
    );
};
